import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, CardBody, Card } from 'reactstrap';
import SupportDocs from './component/SupportDocs';

import { api } from '../../config';
import 'react-datepicker/dist/react-datepicker.css';
import logger from '../../utils/logger';

const pick = (obj, camelKey, pascalKey) =>
  obj?.[camelKey] ?? obj?.[pascalKey] ?? null;

const stripFileExtension = fileName => {
  if (fileName == null) return null;
  const normalized = String(fileName).trim();
  if (!normalized) return null;
  return normalized.replace(/\.[^/.]+$/, '');
};

const unwrapProcurementDocumentItems = payload => {
  if (!payload) return [];

  const root = payload?.data ?? payload?.Data ?? payload;
  const nested = root?.data ?? root?.Data ?? root;

  const candidates = [
    nested?.items,
    nested?.Items,
    root?.items,
    root?.Items,
    Array.isArray(nested) ? nested : null,
    Array.isArray(root) ? root : null,
  ];

  const items = candidates.find(Array.isArray);
  return items ?? [];
};

const mapProcurementDocumentItem = (item, formatDate) => {
  if (!item || typeof item !== 'object') return null;

  const link = pick(item, 'link', 'Link');
  const rawCustomFileName = pick(item, 'customFileName', 'CustomFileName');
  const customFileName = stripFileExtension(rawCustomFileName);
  const documentUpload = item?.documentUpload ?? item?.DocumentUpload;

  const defaultFormatDate = dateStr => {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const format = formatDate ?? defaultFormatDate;

  return {
    id: pick(item, 'id', 'Id') ?? null,
    customFileName,
    documentName:
      documentUpload?.documentName ?? documentUpload?.DocumentName ?? null,
    documentUploadId:
      pick(item, 'documentUploadId', 'DocumentUploadId') ?? null,
    actualUrl: link ?? null,
    isMasterDocument: !link,
    isShowToDMUT: pick(item, 'isShowToDMUT', 'IsShowToDMUT') ?? false,
    lastUpdated: format(pick(item, 'updatedDate', 'UpdatedDate')),
    createdDate: format(pick(item, 'createdDate', 'CreatedDate')),
  };
};

const mapProcurementDocuments = (payload, formatDate) =>
  unwrapProcurementDocumentItems(payload)
    .map(item => mapProcurementDocumentItem(item, formatDate))
    .filter(Boolean);

const SupportDocumentTab = ({
  ids,
  form,
  _error,
  _isLoading,
  _qtyDeliveryData,
  token,
}) => {
  const [uploadDocument, setUploadDocument] = useState({ items: [] });
  const [searchText, setSearchText] = useState('');
  const [isLoadingDocuments, setIsLoadingDocuments] = useState(false);

  const fetchDocumentUpload = useCallback(
    async procurementId => {
      setIsLoadingDocuments(true);
      try {
        const response = await fetch(
          `${api.API_URL}/procurement/get-procurement-document?ProcurementId=${procurementId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error('Failed to load supporting documents');
        }

        const result = await response.json();
        setUploadDocument({ items: mapProcurementDocuments(result) });
      } catch (error) {
        logger.error('Error fetching data from HPS API:', error);
        setUploadDocument({ items: [] });
      } finally {
        setIsLoadingDocuments(false);
      }
    },
    [token]
  );

  useEffect(() => {
    if (ids) {
      fetchDocumentUpload(ids);
    }
  }, [ids, fetchDocumentUpload]);

  const filteredDocuments = uploadDocument.items.filter(doc => {
    const term = searchText.trim().toLowerCase();
    if (!term) return true;
    const name = (doc.documentName || '').toLowerCase();
    return name.includes(term);
  });

  return (
    <React.Fragment>
      <Row>
        {/* <div className="mt-4"> */}
        <div>
          <Card className='border shadow-sm'>
            <CardBody>
              <Row>
                <Col sm={12}>
                  <div
                    color='dark'
                    className='d-flex align-items-center mb-2  '
                  >
                    <div className='flex-grow-1'>
                      <h5 className='mb-1'>Supporting Document</h5>
                      <p className='text-muted mb-2 fs-12 '>
                        Bisa jadi Kalimat tambahan untuk membantu section
                        mengenai apa ini
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={12}>
                  <SupportDocs
                    documents={filteredDocuments}
                    isLoading={isLoadingDocuments}
                    searchText={searchText}
                    onSearchChange={setSearchText}
                    onClearSearch={() => setSearchText('')}
                    isReadOnly={form.statusHPS2 === true}
                    showDmutBadge
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </Row>
    </React.Fragment>
  );
};

export default SupportDocumentTab;
